export const UnauthorizedPage = () => {
  return (
    <>
      <h1>401 Unauthorized</h1>
    </>
  );
};
